import {IconSizeProps} from "./types";

export default function SOLLightIcon({size = 40, ...props}: IconSizeProps) {
    return <svg width={size} height={size} {...props} viewBox="0 0 40 40" fill="none"
                xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.1239 24.7415C12.2647 24.6007 12.4583 24.5186 12.6636 24.5186H31.2838C31.6241 24.5186 31.7942 24.9292 31.5537 25.1697L27.8754 28.848C27.7346 28.9888 27.541 29.0709 27.3357 29.0709H8.71551C8.37526 29.0709 8.20513 28.6603 8.44565 28.4198L12.1239 24.7415Z"
            fill="white"/>
        <path
            d="M12.1242 11.0081C12.2708 10.8673 12.4644 10.7852 12.6639 10.7852H31.2841C31.6243 10.7852 31.7945 11.1958 31.5539 11.4363L27.8757 15.1146C27.7349 15.2554 27.5413 15.3375 27.3359 15.3375H8.71576C8.3755 15.3375 8.20537 14.9269 8.4459 14.6864L12.1242 11.0081Z"
            fill="white"/>
        <path
            d="M27.8754 17.8299C27.7346 17.6891 27.541 17.6069 27.3357 17.6069H8.71551C8.37526 17.6069 8.20513 18.0176 8.44565 18.2581L12.1239 21.9364C12.2647 22.0772 12.4583 22.1593 12.6636 22.1593H31.2838C31.6241 22.1593 31.7942 21.7487 31.5537 21.5081L27.8754 17.8299Z"
            fill="white"/>

    </svg>

}